import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const dynamicDeleteEndpoint = ApiEndpoints.dynamicPage.dynamicDelete;
const dynamicListEndpoint = ApiEndpoints.dynamicPage.dynamicList;


const dynamicEditPath = "edit-dynamic";
const tableHeader = ["Title", "Description", "Slug"];
const tbody = ["section1_title", "section1_description", "slug"];

export default function Dynamic() {
  const [data, setData] = useState([]);
  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", dynamicListEndpoint);
      const result = response.dynamicpages;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (dynamicpage_id) => {
    const payload = { dynamicpage_id };
    try {
      const response = await ApiRequest("POST", dynamicDeleteEndpoint, payload);
      toast.success(response.message)
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'Dynamic Management',
    user: 'Admin',
    innerpage: 'Dynamic Management / Dynamic'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />
      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-dynamic">Add +</Link>
        <DataTable data={data} tableHeader={tableHeader} tbody={tbody} editPath={dynamicEditPath}
          onDelete={handleDelete} />
      </div>
    </>
  );
}



